import { Step1WritingMetadata, isStep1PathSelected } from '../types/step1Writing';
import { modeLabel } from '../utils/step1WritingLabels';
import { formatAloudDurationLabel } from '../utils/readTimeEstimate';

/** One-line progress summary for Action 3 (only when a method is selected). */
export function formatStep1ProgressLine(metadata: Step1WritingMetadata): string {
  if (!isStep1PathSelected(metadata)) return '';

  const parts: string[] = [modeLabel(metadata.mode)];

  if (metadata.wordCount && metadata.wordCount > 0) {
    parts.push(`${metadata.wordCount.toLocaleString()} words`);
    const aloud = formatAloudDurationLabel(metadata.wordCount);
    if (aloud) parts.push(aloud);
  } else if (metadata.hasContent) {
    parts.push('in progress');
  } else {
    parts.push('started');
  }

  if (metadata.lastWorkedAt) {
    const d = new Date(metadata.lastWorkedAt);
    parts.push(
      `last worked ${d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`
    );
  }

  return parts.join(' · ');
}
